// extracted by mini-css-extract-plugin
export default {"label__filter":"FilterProducts_label__filter__PyVUg","dropdown__category":"FilterProducts_dropdown__category__UC36N"};